<template lang="pug">
	modal.modal(name="row-editor", @before-open="beforeOpen", height="auto", :scrollable="true", :class="type")
		.modal-content(v-if="type === 'add' || type === 'edit'")
			.modal-component(v-for="header in headers") 
				h6.modal-content-title {{header._display}}
				component(
					:is="`modal-${header.editorType}`", 
					v-model="model[header._id]", 
					:header="header")
			.modal-content-buttons
				button.modal-content-button.btn.btn--secondary(type="button", @click="hide") Cancel
				button.modal-content-button.btn(type="button", v-on="type === 'add' ? {click: add} : {click: save}") {{type === 'add' ? 'Add' : 'Save'}}
		.modal-content(v-else-if="type=='delete'")
			h6.modal-content-title Delete Row
			p.modal-content-copy Are you sure you want to delete this row?
			.modal-content-buttons
				button.modal-content-button.btn.btn--secondary(type="button", @click="hide") No
				button.modal-content-button.btn(type="button", @click="remove") Yes
</template>

<script>
import Bool from "./editors/Bool";
import Picklist from "./editors/Picklist";
import Textbox from "./editors/Textbox";
import Wysiwyg from "./editors/Wysiwyg";
import { cloneDeep } from "lodash-es";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { decode } from "punycode";
import { filter } from "minimatch";
export default {
  name: "MatrixRowEditor",
  components: {
    modalBool: Bool,
    modalPicklist: Picklist,
    modalTextbox: Textbox,
    modalWysiwyg: Wysiwyg
  },
  data() {
    return {
      type: null,
      data: null,
      insertAfter: null,
      model: {}
    };
  },
  computed: {
    ...mapGetters(["computed"]),
    headers() {
      return this.computed.headers;
    },
    error() {
      let model = Object.entries(this.model);
      return model.every(cell => cell[1].length);
    }
  },
  methods: {
    ...mapMutations(["updateRows"]),
    ...mapActions(["newBuild", "rebuild"]),
    add() {
      let cells = Object.entries(this.model);
      cells.forEach((cell, i) => {
        if (Array.isArray(cell[1])) {
          cell[1] = cell[1].map(item => item.key);
        }
      });
      this.newBuild({ data: cells, insertAfter: this.insertAfter });
      this.hide();
    },
    save() {
      let cells = cloneDeep(this.data);
      cells.forEach((cell, i) => {
        let model = this.model[cell._column];
        if (cell._editorType === "picklist") {
          cell.key = model.map(item => item.key);
        } else if (cell._editorType === "bool") {
          cell.bool = model;
        } else {
          if (cell._filterable) {
            let regex = new RegExp(cell._regex);
            let filterTag = regex.exec(model);
            if (filterTag) filterTag = filterTag[1] || model;
            else filterTag = model;
            cell.filterTag = filterTag;
          }
          cell.value = model;
        }
			});
      this.rebuild([cells[0]._row, cells]);

      this.hide();
    },
    remove() {
      let payload = cloneDeep(this.computed.rows);
      delete payload[this.data[0]._row];
      this.updateRows(payload);
      this.hide();
    },
    hide() {
      this.$modal.hide("row-editor");
    },
    beforeOpen(e) {
      this.type = e.params.type;
      this.data = e.params.data;
      this.insertAfter = e.params.insertAfter;
      this.computed.headers.forEach(header =>
        this.$set(this.model, header._id, undefined)
      );
      if (this.type === "edit") {
        this.data.forEach(cell => {
          let model = this.model;
          if (cell._editorType === "picklist") {
            model[cell._column] = cell.key.map((key, i) => {
              return { key, value: i === 0 ? cell._filterTag : key };
            });
          } else if (cell._editorType === "bool") {
            model[cell._column] = cell.bool === undefined ? null : cell.bool;
          } else {
            model[cell._column] = cell.value;
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  z-index: 20;
}

.modal-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
  .delete & {
    align-items: center;
  }
}

.modal-component {
  display: flex;
  margin: 0 0 30px;
}

.modal-content-title {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 20px;
  .delete & {
    color: $empire;
  }
  .edit &,
  .add & {
    align-self: flex-start;
    width: 120px;
    margin-right: 20px;
    font-size: 20px;
    margin-bottom: 0;
    flex: 0 0 120px;
    text-align: right;
    padding-bottom: 5px;
    position: relative;
    &::before {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      height: 2px;
      background: $mist;
      content: "";
    }
    &::after {
      content: ":";
    }
  }
}

.modal-content-copy {
  font-size: 16px;
}

.modal-content-buttons {
  display: flex;
  align-self: flex-end;
}

.modal-content-button {
  margin: 0 5px;
}
</style>